<template>
  <a class="specials__special-box-link" :href="`/announcements/${specialId}`">
    <div class="specials__special-box">
      <img
        v-lazy="imageUrl"
        class="specials__special-box__image"
        alt="specialId"
      />
      <div class="specials__special-box__text">
        <p class="specials__special-box__date">
          {{ startedAt }}
        </p>
        <p class="specials__special-box__title">
          {{ specialTitle }}
        </p>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    specialId: {
      type: Number,
      required: true
    },
    specialTitle: {
      type: String,
      required: true
    },
    startedAt: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.specials {
  &__special-box-link {
    width: 100%;
    margin-bottom: 16px;
  }

  &__special-box-link:last-child {
    margin-bottom: 0;
  }

  &__special-box {
    display: flex;

    &__image {
      max-width: 100%;
      width: 108px;
      height: 56.5px;
    }

    &__text {
      display: flex;
      padding-left: 8px;
      flex-direction: column;
      text-align: left;
      // boxのサイズ - 画像のサイズ - paddingのサイズ
      max-width: calc(100% - 108px - 8px);
    }

    &__date {
      padding-bottom: 4px;
      font-size: 1rem;
      line-height: 1.6;
      color: $gray-1;
    }

    &__title {
      font-size: 1.2rem;
      line-height: 1.6;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: $black;
    }
  }
}
</style>
